module.exports = __webpack_public_path__ + "static/media/icon-view.59a36ca8.svg";